import * as React from 'react';
// import 'style/index.scss';
import './styles/index.scss'
// import { BoardMode, Shape, Rectangle, Size, Point } from '..';


export enum BoardMode {
    /**
     * 显示模式
     */
    ReadOnly = 0,
    /**
     * 编辑模式
     */
    Edit = 1,
}

export enum ShapeTypeEnum {
    Rectangle,
    Line,
    Circle,
    // Ellipse,
    Polyline,
    polygon,
}

export interface Point { x: number, y: number }
export interface Size { width: number, height: number }
export interface Rectangle extends Point, Size { } // <rect x="120" y="120" width="100" height="100" rx="15" ry="15" /> 矩形
export interface Line { startPoint: Point, endPoint: Point } // <line x1="0" y1="80" x2="100" y2="20" stroke="black" /> 线
export interface Circle { originalPoint: Point, r: number } // <circle cx="50" cy="50" r="50"/>  圆
export interface Ellipse { originalPoint: Point, rx: number, ry: number } // <ellipse cx="100" cy="50" rx="100" ry="50" />  椭圆
export interface Multipoint { points: Point[] } //   <polygon points="100,100 150,25 150,75 200,0" fill="none" stroke="black" /> 闭合多边形
// <polyline points="100,100 150,25 150,75 200,0" fill="none" stroke="black" /> 多段折线

export type ShapeType = Rectangle | Line | Circle | Ellipse | Multipoint;
export interface Shape<T = ShapeType> { key?: any, type: ShapeTypeEnum, shape: T, tag?: any }

export interface SvgImageBoardProps {
    imageUrl: string,
    mode: BoardMode,
    initShapes?: Array<Shape<ShapeType>>,
    onLoad?: (board: SvgImageBoard) => void,
    onDeletedShape?: (shape: Shape<ShapeType>) => void,
    onCreatedShape?: (shape: Shape<ShapeType>) => void,
    onUpdatedShape?: (shape: Shape<ShapeType>) => void,
    /**
     * 每次缩放的比例
     */
    scaleNum?: number,
    /**
     * 最大缩放比例
     */
    maxScale?: number,
    /**
     * 最小缩放比例
     */
    minScale?: number,
    shapeClassName?: string,
    drawShapeType?: ShapeTypeEnum
}

interface SvgImageBoardPropsState {
    uploading: boolean,
    imageUrl: string,
    imageSize: Size,
    currentEditIndex: number,
    shapes: Array<Shape<ShapeType>>,
};

export class SvgImageBoard extends React.Component<SvgImageBoardProps, SvgImageBoardPropsState> {
    private _isMouseDown: boolean = false;
    private _mouseTarget?: SVGElement;
    private _mouseDownPostion: Point = { x: 0, y: 0 };
    private _lastMousePosition: Point = { x: 0, y: 0 };
    private mainBoxRef: React.RefObject<SVGSVGElement>;
    private mapscaleControlRef: React.RefObject<SVGGElement>;
    private drawRectRef: React.RefObject<SVGRectElement>;

    static defaultProps =  {
        scaleNum: 0.1,
        maxScale: 5,
        minScale: 0.1,
        shapeClassName: 'red',
        drawShapeType: ShapeTypeEnum.Rectangle
    };
    constructor(props: SvgImageBoardProps) {
        super(props);
        this.state = {
            uploading: false,
            imageUrl: '',
            imageSize: {
                width: 100,
                height: 100
            },
            currentEditIndex: -1,
            shapes: props.initShapes || []
        };
        this.mainBoxRef = React.createRef<SVGSVGElement>();
        this.mapscaleControlRef = React.createRef<SVGGElement>();
        this.drawRectRef = React.createRef<SVGRectElement>();
    }
    componentDidMount() {
        this.props.onLoad?.call(this, this);
        const { imageUrl } = this.props;
        setTimeout(() => {
            this.preLoadImage(imageUrl);
        }, 100);
        window.addEventListener('resize', this.resize);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }

    private resize = (e: UIEvent) => {
        if (this.mainBoxRef.current) {
            const { imageSize } = this.state;
            this.setImageDefaultRatio(imageSize);
        }
    }
    preLoadImage = (imageUrl: string) => {
        if (imageUrl) {
            const img = new Image();
            img.onload = e => {
                const imageSize = {
                    width: img.naturalWidth,
                    height: img.naturalHeight
                };
                this.setState({
                    imageUrl,
                    imageSize
                });
                this.setImageDefaultRatio(imageSize);
            };
            img.src = imageUrl;
        }
    };
    private setImageDefaultRatio = (imageSize: Size) => {
        if (!this.props.imageUrl || !this.mainBoxRef.current) return;

        const boxSize = {
            width: this.mainBoxRef.current?.clientWidth as number,
            height: this.mainBoxRef.current?.clientHeight as number
        };
        // 设置初始图像比例
        let scaleRatio = 1;
        let scalePoint = { x: 0, y: 0 };
        if (boxSize.width / imageSize.width < boxSize.height / imageSize.height) {
            scaleRatio = boxSize.width / imageSize.width;
            scalePoint.y = (boxSize.height - (imageSize.height * scaleRatio)) / 2;
        } else {
            scaleRatio = boxSize.height / imageSize.height;
            scalePoint.x = (boxSize.width - (imageSize.width * scaleRatio)) / 2;
        }
        this.mapscaleControlRef.current?.setAttribute('transform', `matrix(${scaleRatio},0,0,${scaleRatio},${scalePoint.x},${scalePoint.y})`);
    }
    private onkeydown = (e: KeyboardEvent) => {
        if (e.keyCode === 46) { // Delete rect
            e.stopImmediatePropagation();
            const { mode, onDeletedShape } = this.props;
            const { currentEditIndex, shapes } = this.state;
            if (mode === BoardMode.Edit && currentEditIndex >= 0) {
                const removes = shapes.splice(currentEditIndex, 1);
                if (removes && removes.length > 0) {
                    this.setState({
                        shapes: [...shapes],
                        currentEditIndex: -1
                    })
                    onDeletedShape?.call(this, removes[0]);
                }
            }
        }
    };
    private mainMouseDown = (evt: React.MouseEvent<SVGSVGElement, MouseEvent>) => { // e.button  0 : left button  1  是滚轮按键 2是右键
        const e = evt.nativeEvent;
        e.stopImmediatePropagation();
        if (e.button !== 0) return; // 仅支持左键操作
        this._mouseTarget = e.target as SVGElement;
        this._isMouseDown = true;
        const x = e.offsetX;
        const y = e.offsetY;

        this._mouseDownPostion = { x, y };
        this._lastMousePosition = this._mouseDownPostion;
    };
    private mainMouseMove = (evt: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
        if (!this._isMouseDown) return;
        const e = evt.nativeEvent;
        e.stopImmediatePropagation();
        const { mode } = this.props;
        const x = e.offsetX;
        const y = e.offsetY;
        const translateX = x - this._lastMousePosition.x;
        const translateY = y - this._lastMousePosition.y;

        switch (mode) {
            case BoardMode.ReadOnly:// move backgroud
                let matrix = this.mapscaleControlRef.current?.getCTM();
                matrix = matrix?.translate(translateX / matrix.a, translateY / matrix.d) as DOMMatrix; // 矩阵偏移函数
                this.ResetTransform(matrix);
                this._lastMousePosition = { x, y };

                break;
            case BoardMode.Edit:
                if (this._mouseTarget && (this._mouseTarget.tagName === 'rect')) { // 移动矩形
                    const matrix = this.mapscaleControlRef.current?.getCTM() as DOMMatrix;
                    const svgContainer = this._mouseTarget.parentNode as SVGSVGElement;
                    const nowX = parseFloat(svgContainer.getAttribute('x') || '0') + (translateX / matrix.a);
                    const nowY = parseFloat(svgContainer.getAttribute('y') || '0') + (translateY / matrix.d);
                    svgContainer.setAttribute('x', nowX.toString());
                    svgContainer.setAttribute('y', nowY.toString());
                    this._lastMousePosition = { x, y };
                } else if (this._mouseTarget && this._mouseTarget.tagName === 'circle') {
                    const matrix = this.mapscaleControlRef.current?.getCTM() as DOMMatrix;
                    const svgContainer = this._mouseTarget.parentNode as SVGSVGElement;
                    const oldItem = {
                        x: parseFloat(svgContainer.getAttribute('x') || '0'),
                        y: parseFloat(svgContainer.getAttribute('y') || '0'),
                        width: parseFloat(svgContainer.getAttribute('width') || '0'),
                        height: parseFloat(svgContainer.getAttribute('height') || '0')
                    };
                    let nowItem: any = {};
                    const className = this._mouseTarget.className.baseVal;
                    // console.log('className', className);
                    switch (className) {
                        case 'left-top':
                            nowItem = {
                                x: oldItem.x + (translateX / matrix.a),
                                y: oldItem.y + (translateY / matrix.d),
                                width: oldItem.width - (translateX / matrix.a),
                                height: oldItem.height - (translateY / matrix.d)
                            };
                            if (nowItem.x < oldItem.x + oldItem.width && nowItem.y < oldItem.y + oldItem.height) {
                                svgContainer.setAttribute('x', nowItem.x);
                                svgContainer.setAttribute('y', nowItem.y);
                                svgContainer.setAttribute('width', nowItem.width);
                                svgContainer.setAttribute('height', nowItem.height);
                            }
                            break;
                        case 'left':
                            nowItem = {
                                x: oldItem.x + (translateX / matrix.a),
                                width: oldItem.width - (translateX / matrix.a)
                            };
                            if (nowItem.x < oldItem.x + oldItem.width) {
                                svgContainer.setAttribute('x', nowItem.x);
                                svgContainer.setAttribute('width', nowItem.width);
                            }
                            break;
                        case 'left-bottom':
                            nowItem = {
                                x: oldItem.x + (translateX / matrix.a),
                                width: oldItem.width - (translateX / matrix.a),
                                height: oldItem.height + (translateY / matrix.d)
                            };
                            if (nowItem.x < oldItem.x + oldItem.width && nowItem.height > 0) {
                                svgContainer.setAttribute('x', nowItem.x);
                                svgContainer.setAttribute('width', nowItem.width);
                                svgContainer.setAttribute('height', nowItem.height);
                            }
                            break;
                        case 'top':
                            nowItem = {
                                y: oldItem.y + (translateY / matrix.d),
                                height: oldItem.height - (translateY / matrix.d)
                            };
                            if (nowItem.height > 0) {
                                svgContainer.setAttribute('y', nowItem.y);
                                svgContainer.setAttribute('height', nowItem.height);
                            }
                            break;
                        case 'bottom':
                            nowItem = {
                                height: oldItem.height + (translateY / matrix.d)
                            };
                            if (nowItem.height > 0) {
                                svgContainer.setAttribute('height', nowItem.height);
                            }
                            break;
                        case 'right-top':
                            nowItem = {
                                y: oldItem.y + (translateY / matrix.d),
                                width: oldItem.width + (translateX / matrix.a),
                                height: oldItem.height - (translateY / matrix.d)
                            };
                            if (nowItem.width > 0 && nowItem.height > 0) {
                                svgContainer.setAttribute('y', nowItem.y);
                                svgContainer.setAttribute('width', nowItem.width);
                                svgContainer.setAttribute('height', nowItem.height);
                            }
                            break;
                        case 'right':
                            nowItem = {
                                width: oldItem.width + (translateX / matrix.a)
                            };
                            if (nowItem.width > 0) {
                                svgContainer.setAttribute('width', nowItem.width);
                            }
                            break;
                        case 'right-bottom':
                            nowItem = {
                                width: oldItem.width + (translateX / matrix.a),
                                height: oldItem.height + (translateY / matrix.d)
                            };
                            if (nowItem.width > 0 && nowItem.height > 0) {
                                svgContainer.setAttribute('width', nowItem.width);
                                svgContainer.setAttribute('height', nowItem.height);
                            }
                            break;

                        default:
                            break;
                    }

                    this._lastMousePosition = { x, y };
                } else { // 画虚线框
                    this.setDrawRect({
                        x: Math.min(this._mouseDownPostion.x, x),
                        y: Math.min(this._mouseDownPostion.y, y),
                        height: Math.abs(this._mouseDownPostion.y - y),
                        width: Math.abs(this._mouseDownPostion.x - x)
                    });
                }

                break;

            default:
                break;
        }
    };
    private mainMouseUp = (evt: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
        if (!this._isMouseDown) return;
        const e = evt.nativeEvent;
        e.stopImmediatePropagation();
        if (e.button !== 0) return; // 仅支持左键操作
        const { mode, onCreatedShape, onUpdatedShape, drawShapeType } = this.props;
        const { currentEditIndex, shapes } = this.state;
        const x = e.offsetX;
        const y = e.offsetY;
        switch (mode) {
            case BoardMode.ReadOnly:
                break;
            case BoardMode.Edit:
                if (Math.abs(x - this._mouseDownPostion.x) > 1 || Math.abs(y - this._mouseDownPostion.y) > 1) { // 鼠标有移动
                    // console.log('this._mouseTarget', this._mouseTarget);
                    if (this._mouseTarget) {
                        if (this._mouseTarget.tagName === 'image') { // 创建矩形
                            if (drawShapeType === ShapeTypeEnum.Rectangle) {
                                if (Math.abs(x - this._mouseDownPostion.x) > 5 && Math.abs(y - this._mouseDownPostion.y) > 5) { // 创建尺寸大于5*5
                                    let matrix = this.mapscaleControlRef.current?.getCTM() as DOMMatrix;
                                    let rectX = Math.min(this._mouseDownPostion.x, x);
                                    let rectY = Math.min(this._mouseDownPostion.y, y);
                                    rectX = (rectX - matrix.e) / matrix.a;
                                    rectY = (rectY - matrix.f) / matrix.d;
                                    let theWidth = Math.abs(this._mouseDownPostion.x - x) / matrix.a;
                                    let theHeight = Math.abs(this._mouseDownPostion.y - y) / matrix.d;

                                    const rect: Shape<Rectangle> = {
                                        type: ShapeTypeEnum.Rectangle,
                                        shape: {
                                            x: rectX,
                                            y: rectY,
                                            width: theWidth,
                                            height: theHeight
                                        }
                                    };
                                    shapes.push(rect);
                                    this.setState({ shapes: [...shapes], currentEditIndex: shapes.length - 1 });
                                    onCreatedShape?.call(this, rect);
                                }
                                this.setDrawRect({ x: 0, y: 0, height: 0, width: 0 });
                            }
                        } else if (this._mouseTarget.tagName === 'rect') { // 移动矩形

                            const matrix = this.mapscaleControlRef.current?.getCTM() as DOMMatrix;
                            const translateX = x - this._lastMousePosition.x;
                            const translateY = y - this._lastMousePosition.y;

                            const svgContainer = this._mouseTarget.parentNode as SVGSVGElement;

                            const nowX = parseFloat(`${svgContainer.getAttribute('x')}`) + (translateX / matrix.a);
                            const nowY = parseFloat(`${svgContainer.getAttribute('y')}`) + (translateY / matrix.d);

                            const rect = shapes[currentEditIndex];
                            const shape = rect.shape as Rectangle;
                            shape.x = nowX;
                            shape.y = nowY;
                            rect.shape = shape;
                            this.setState({ shapes: [...shapes] });
                            onUpdatedShape?.call(this, rect);
                        } else if (this._mouseTarget.tagName === 'circle') { // 矩形拉伸
                            const svgContainer = this._mouseTarget.parentNode as SVGSVGElement;
                            const rect = shapes[currentEditIndex];
                            rect.shape = {
                                x: parseFloat(svgContainer.getAttribute('x') as string),
                                y: parseFloat(svgContainer.getAttribute('y') as string),
                                width: parseFloat(svgContainer.getAttribute('width') as string),
                                height: parseFloat(svgContainer.getAttribute('height') as string)
                            }
                            this.setState({ shapes: [...shapes] });
                            onUpdatedShape?.call(this, rect);
                        } else if (this._mouseTarget.tagName === 'svg' && this._mouseTarget.className.baseVal === 'mainBox') {
                            this.setDrawRect({ x: 0, y: 0, height: 0, width: 0 });
                        }
                    }
                }
                break;

            default:
                break;
        }
        this._isMouseDown = false;
    };
    private mainMouseWheel = (evt: React.WheelEvent<SVGSVGElement>) => {
        if (this._isMouseDown) return;
        const { scaleNum = 0.1 } = this.props;
        const e = evt.nativeEvent;
        e.stopImmediatePropagation();
        let zoomScale = 1;
        // if (e.wheelDelta > 0) {
        if (e.deltaY < 0) {
            zoomScale += scaleNum;
        } else {
            zoomScale -= scaleNum;
        }

        // if (evt.target.id.indexOf("mainBox") != -1) { //鼠标在缩放控件外，主容器内  //|| evt.target.id == "tempImg"
        //   scalePoint = null;
        // }
        this.setZoomScale(zoomScale, { 'x': e.offsetX, 'y': e.offsetY });

    };

    // // 获取元素 距离页面根元素的距离
    // getPos = (obj) => {
    //   let pos = { 'top': 0, 'left': 0 };
    //   if (obj.offsetParent) {
    //     while (obj.offsetParent) {
    //       pos.top += obj.offsetTop;
    //       pos.left += obj.offsetLeft;
    //       obj = obj.offsetParent;
    //     }
    //   } else if (obj.x) {
    //     pos.left += obj.x;
    //   } else if (obj.x) {
    //     pos.top += obj.y;
    //   }
    //   return pos;
    // }

    /**
     * 设置缩放比例
     * @zoomScale 缩放比例
     * @scalePoint 缩放中心点
     */
    public setZoomScale = (zoomScale: number, scalePoint?: Point) => {
        let matrix = this.mapscaleControlRef.current?.getCTM() as DOMMatrix;
        const { maxScale = 5, minScale = 0.1 } = this.props;

        if ((matrix.a >= maxScale || matrix.d >= maxScale) && zoomScale > 1) { // 超出或达到最大比例
            return;
        } else if ((matrix.a <= minScale || matrix.d <= minScale) && zoomScale < 1) { // 超出或达到最小比例
            return;
        }

        if ((matrix.a * zoomScale > maxScale || matrix.d * zoomScale > maxScale) && zoomScale > 1) { // 放大比例超过最大比例，则取最大比例
            if (matrix.a > matrix.d) {
                zoomScale = maxScale / matrix.a;
            } else {
                zoomScale = maxScale / matrix.d;
            }
        } else if ((matrix.a * zoomScale < minScale || matrix.d * zoomScale < minScale) && zoomScale < 1) { // 缩小比例超过最小比例，则取最小比例
            if (matrix.a < matrix.d) {
                zoomScale = minScale / matrix.a;
            } else {
                zoomScale = minScale / matrix.d;
            }
        }

        let offsetX = 0; // 偏移缩放后实际的偏移量
        let offsetY = 0;

        if (scalePoint) {
            offsetX = (scalePoint.x - matrix.e);// / matrix.a * matrix.a;//偏移缩放后实际的偏移量
            offsetY = (scalePoint.y - matrix.f);// / matrix.d * matrix.d;
        } else {
            offsetX = (this.mainBoxRef.current as SVGSVGElement).clientWidth * matrix.a / 2; // 缩放控件中心点X
            offsetY = (this.mainBoxRef.current as SVGSVGElement).clientHeight * matrix.d / 2; // 缩放控件中心点Y
        }

        const translateX = offsetX - (offsetX * zoomScale);
        const translateY = offsetY - (offsetY * zoomScale);

        matrix = matrix.translate(translateX / matrix.a, translateY / matrix.d);
        matrix = matrix.scale(zoomScale);
        this.ResetTransform(matrix);
    }

    /**
     * 设置原始缩放比例
     */
    public setOriginalScale = () => {
        this.mapscaleControlRef.current?.setAttribute('transform', 'matrix(1,0,0,1,0,0)')
    }

    // 设置缩放控件矩阵
    private ResetTransform = (Matrix: DOMMatrix) => {
        // console.info("last matrix(" + Matrix.a + "," + Matrix.b + "," + Matrix.c + "," + Matrix.d + "," + Matrix.e + "," + Matrix.f + ")");
        this.mapscaleControlRef.current?.setAttribute('transform', 'matrix(' + Matrix.a + ',' + Matrix.b + ',' + Matrix.c + ',' + Matrix.d + ',' + Matrix.e + ',' + Matrix.f + ')');
    }


    private setDrawRect = (rect: Rectangle) => {
        this.drawRectRef.current?.setAttribute('height', `${rect.height}`);
        this.drawRectRef.current?.setAttribute('width', `${rect.width}`);
        this.drawRectRef.current?.setAttribute('x', `${rect.x}`);
        this.drawRectRef.current?.setAttribute('y', `${rect.y}`);
    }

    /**
     * 获取编辑的数据
     */
    public getData = (): Array<Shape<ShapeType>> => {
        console.log('getData');
        return this.state.shapes;
    }

    render() {
        const { mode, shapeClassName } = this.props;
        const { imageUrl, imageSize, currentEditIndex, shapes } = this.state;
        return (imageUrl &&
            <div style={{ height: '100%' }} onContextMenu={e => e.preventDefault()} onSelect={e => e.preventDefault()} >
                <svg ref={this.mainBoxRef}
                    className="mainBox"
                    onMouseDown={this.mainMouseDown}
                    onMouseMove={this.mainMouseMove}
                    onMouseUp={this.mainMouseUp}
                    onWheel={this.mainMouseWheel}
                    tabIndex={0}
                    onKeyDown={e => this.onkeydown(e.nativeEvent)}
                >
                    <g ref={this.mapscaleControlRef} transform="matrix(1,0,0,1,0,0)">
                        <image href={imageUrl} width={imageSize.width} height={imageSize.height}></image>
                        {shapes && shapes.map((item, index) => {
                            if (item.type === ShapeTypeEnum.Rectangle) {
                                const rectInfo = item.shape as Rectangle;
                                return <svg key={index}  // id={`svg_rect_${index}`}
                                    className={`shape ${shapeClassName} ${currentEditIndex === index ? 'active' : ''} ${mode === BoardMode.Edit ? 'edit' : ''}`}
                                    // x={item.shape.x} y={item.shape.y} height={item.shape.height} width={item.shape.width}
                                    {...rectInfo}
                                    onMouseDown={e => this.setState({ currentEditIndex: index })}
                                >
                                    <rect x='0' y='0' height='100%' width='100%' />
                                    {(mode === BoardMode.Edit && currentEditIndex === index) &&
                                        <>
                                            <circle className="left-top" r="4" cx='0' cy='0' />
                                            <circle className="left" r="4" cx='0' cy='50%' />
                                            <circle className="left-bottom" r="4" cx='0' cy='100%' />
                                            <circle className="top" r="4" cx='50%' cy='0' />
                                            <circle className="bottom" r="4" cx='50%' cy='100%' />
                                            <circle className="right-top" r="4" cx='100%' cy='0' />
                                            <circle className="right" r="4" cx='100%' cy='50%' />
                                            <circle className="right-bottom" r="4" cx='100%' cy='100%' />
                                        </>
                                    }
                                </svg>;

                            } else {
                                return <div key={index} > </div>;
                            }
                        }
                        )}
                    </g>

                    <rect ref={this.drawRectRef} strokeWidth="1" strokeDasharray="6,2" stroke="#15f635" fill="none"></rect>

                </svg >
            </div >
        );
    }
}

export default SvgImageBoard;

